import {Component, Input, OnInit} from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {Observable} from "rxjs";
import {ApiService, RagTemplateDef} from "../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {LoaderContainerComponent} from "../../../core/loader-container/loader-container.component";
import {NgIf} from "@angular/common";
import {DataPreviewComponent} from "../../../core/data-preview/data-preview.component";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {ManageButtonComponent} from "../../../core/manage-button/manage-button.component";
import {DeleteButtonComponent} from "../../../core/delete-button/delete-button.component";
import {DataTableComponent} from "../../../core/data-table/data-table.component";
import {QuickPreviewPanelComponent} from "../../../core/quick-preview-panel/quick-preview-panel.component";
import {UserIdTagComponent} from "../../users/user-id-tag/user-id-tag.component";

@Component({
  selector: 'templating-preview',
  standalone: true,
  imports: [
    LoaderContainerComponent,
    NgIf,
    DataPreviewComponent,
    ActionsContainerComponent,
    BackButtonComponent,
    ManageButtonComponent,
    DeleteButtonComponent,
    DataTableComponent,
    QuickPreviewPanelComponent,
    UserIdTagComponent
  ],
  templateUrl: './templating-preview.component.html',
})
export class TemplatingPreviewComponent implements OnInit {

  @Input() hideActions = false
  @Input() color: ThemePalette

  templateId?: string
  loader?: Observable<RagTemplateDef>
  template?: RagTemplateDef

  constructor(
    readonly api: ApiService,
    readonly activatedRoute: ActivatedRoute,
    readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.templateId = this.activatedRoute.snapshot.params['templateId']
    this.loader = this.api.getTemplate(this.templateId!)
  }
}
